<template>
  <div>
    <modalWindow v-if="detailsModal" @close="detailsModal = false" width="600">
      <div class="titlebar">Bandbreedtes #{{ detailsResult.port }}</div>
      <div class="card" style="padding: 10px 0 10px 10px">
        <div
          :class="['msg', 'icon', 'warning']"
          style="margin-bottom: 10px"
          v-if="!detailsResult.user || !detailsResult.manager"
        >
          <div class="icon">
            <awesomeIcon icon="info-circle"/>
          </div>
          <template v-if="!detailsResult.user && !detailsResult.manager">
            Er is geen cliënt en geen manager gekoppeld aan de portefeuille.
          </template>
          <template v-else>
            Er is geen {{ !detailsResult.user ? 'cliënt' : 'Account manager' }} gekoppeld aan de
            portefeuille.
          </template>
        </div>
        <table v-else class="new" style="margin-bottom: 10px">
          <thead class="table-legend">
            <tr>
              <th></th>
              <th>Naam</th>
              <th>Email</th>
              <th></th>
            </tr>
          </thead>
          <tr>
            <th width="25%">Cliënt</th>
            <td class="concat150">{{ find(users, { id: detailsResult.user }).name }}</td>
            <td class="concat150">{{ find(users, { id: detailsResult.user }).email }}</td>
            <td>
              <button @click="openUserInCrm(detailsResult.user)" class="secondary">
                <awesomeIcon icon="level-up-alt"/> Open in CRM
              </button>
            </td>
          </tr>
          <tr>
            <th width="25%">Account manager</th>
            <td class="concat150">{{ find(users, { id: detailsResult.manager }).name }}</td>
            <td class="concat150">{{ find(users, { id: detailsResult.manager }).email }}</td>
            <td></td>
          </tr>
        </table>

        <b style="font-size: 15px">Bandbreedtes</b>
        <table class="new">
          <thead class="table-legend">
            <tr>
              <th></th>
              <th>% van de portefeuille</th>
              <th>% in vreemde valuta</th>
            </tr>
          </thead>
          <tr>
            <th style="width: 25%;">Aandelen</th>
            <td>
              <b>{{ formatPrice(detailsResult.shares) }}%<br></b>
              &euro; {{ formatPrice(detailsResult.worth * detailsResult.shares / 100) }}
            </td>
            <td v-if="Number(detailsResult.shares) > 0">
              <b>
                {{
                  formatPrice(
                    (detailsResult.shares_foreign / 100)
                    / (detailsResult.shares / 100)
                    * 100,
                  )
                }}%
              </b><br>
              &euro; {{ formatPrice(
                detailsResult.worth * detailsResult.shares_foreign / 100,
              ) }}
            </td>
            <td v-else>
              <b>0,00%</b><br>
              &euro; 0,00
            </td>
          </tr>
          <tr>
            <th style="width: 25%;">Vast rentend</th>
            <td>
              <b>{{ formatPrice(detailsResult.fixed_interest) }}%</b><br>
              &euro; {{ formatPrice(detailsResult.worth * detailsResult.fixed_interest / 100) }}
            </td>
            <td v-if="Number(detailsResult.fixed_interest) > 0">
              <b>
                {{
                  formatPrice(
                    (detailsResult.fixed_interest_foreign / 100)
                    / (detailsResult.fixed_interest / 100)
                    * 100,
                  )
                }}%
              </b><br>
              &euro; {{ formatPrice(
                detailsResult.worth * detailsResult.fixed_interest_foreign / 100,
              ) }}
            </td>
            <td v-else>
              <b>0,00%</b><br>
              &euro; 0,00
            </td>
          </tr>
          <tr>
            <th style="width: 25%;">Vastgoed</th>
            <td>
              <b>{{ formatPrice(detailsResult.property) }}%</b><br>
              &euro; {{ formatPrice(detailsResult.worth * detailsResult.property / 100) }}
            </td>
            <td v-if="Number(detailsResult.property) > 0">
              <b>
                {{
                  formatPrice(
                    (detailsResult.property_foreign / 100)
                    / (detailsResult.property / 100)
                    * 100,
                  )
                }}%
              </b><br>
              &euro; {{ formatPrice(
                detailsResult.worth * detailsResult.property_foreign / 100,
              ) }}
            </td>
            <td v-else>
              <b>0,00%</b><br>
              &euro; 0,00
            </td>
          </tr>
          <tr>
            <th style="width: 25%;">Beschermd beleggen</th>
            <td>
              <b>{{ formatPrice(detailsResult.protected_investing) }}%</b><br>
              &euro;
              {{ formatPrice(detailsResult.worth * detailsResult.protected_investing / 100) }}
            </td>
            <td v-if="Number(detailsResult.protected_investing) > 0">
              <b>
                {{
                  formatPrice(
                    (detailsResult.protected_investing_foreign / 100)
                    / (detailsResult.protected_investing / 100)
                    * 100,
                  )
                }}%
              </b><br>
              &euro; {{ formatPrice(
                detailsResult.worth * detailsResult.protected_investing_foreign / 100,
              ) }}
            </td>
            <td v-else>
              <b>0,00%</b><br>
              &euro; 0,00
            </td>
          </tr>
          <tr>
            <th style="width: 25%;">Alternatieven</th>
            <td>
              <b>{{ formatPrice(detailsResult.alternatives) }}%</b><br>
              &euro;
              {{ formatPrice(detailsResult.worth * detailsResult.alternatives / 100) }}
            </td>
            <td v-if="Number(detailsResult.alternatives) > 0">
              <b>
                {{
                  formatPrice(
                    (detailsResult.alternatives_foreign / 100)
                    / (detailsResult.alternatives / 100)
                    * 100,
                  )
                }}%
              </b><br>
              &euro; {{ formatPrice(
                detailsResult.worth * detailsResult.alternatives_foreign / 100,
              ) }}
            </td>
            <td v-else>
              <b>0,00%</b><br>
              &euro; 0,00
            </td>
          </tr>
          <tr>
            <th style="width: 25%;">Liquiditeiten</th>
            <td>
              <b>{{ formatPrice(detailsResult.liquidities) }}%</b><br>
              &euro;
              {{ formatPrice(detailsResult.worth * detailsResult.liquidities / 100) }}
            </td>
            <td v-if="Number(detailsResult.liquidities) > 0">
              <b>
                {{
                  formatPrice(
                    (detailsResult.liquidities_foreign / 100)
                    / (detailsResult.liquidities / 100)
                    * 100,
                  )
                }}%
              </b><br>
              &euro; {{ formatPrice(
                detailsResult.worth * detailsResult.liquidities_foreign / 100,
              ) }}
            </td>
            <td v-else>
              <b>0,00%</b><br>
              &euro; 0,00
            </td>
          </tr>
          <tr>
            <th style="width: 25%;"><i>Totaal</i></th>
            <td>
              <i>&euro; {{ formatPrice(detailsResult.worth) }}</i>
            </td>
            <td>
              <i>
                &euro; {{ formatPrice(
                  (detailsResult.foreign_currency / 100) * detailsResult.worth
                ) }}
              </i>
            </td>
          </tr>
        </table>

        <table class="new" style="margin-top: 10px;">
          <tr>
            <th style="width: 50%;">Totale buitenlandse bandbreedtes</th>
            <td>{{ formatPrice(detailsResult.foreign_currency) }}%</td>
          </tr>
          <tr>
            <th style="width: 50%;">Toegestane buitenlandse bandbreedtes</th>
            <td>
              {{ detailsProfile.foreign_currency_min || '0' }}
              - {{ detailsProfile.foreign_currency_max || '0'}}%
            </td>
          </tr>
        </table>
        <br />
      </div>
    </modalWindow>

    <tableFilter
      name="riskFilters"
      ref="filterComp"
      :activeAmount="activeFilters"
      :mainFunction="getBandwidths"
      v-model="filters"
    />

    <div v-if="bandwidths !== null" class="card">
      <table width="100%">
        <thead class="table-legend">
          <tr>
            <th>Port/profiel</th>
            <th>Aandelen</th>
            <th>Vast rentend</th>
            <th>Vastgoed</th>
            <th>Beschermd beleggen</th>
            <th>Alternatieven</th>
            <th>Liquiditeiten</th>
            <th>Vreemde valuta</th>
            <th>Horizon/beheerder</th>
            <th colspan="2"></th>
          </tr>
        </thead>
        <tr v-for="(result, index) in bandwidths" :key="index">
          <td>
            <b>{{ result.port }}</b> <br />
            <p class="concat100 no-margin" :title="result.profileName">
              {{  result.profileName }}
            </p>
          </td>
          <td
            :class="['value', { 'red': result.sharesError }]"
            :title="profileInfo(result.profile, 'shares')"
          >
            {{ formatPrice(result.shares) }}%<br>
            <p>
              &euro;&nbsp;{{ formatPrice((result.shares / 100) * result.worth, true) }}
            </p>
          </td>
          <td
            :class="['value', { 'red': result.fixedInterestError }]"
            :title="profileInfo(result.profile, 'fixed_interest')"
          >
            {{ formatPrice(result.fixed_interest) }}%<br>
            <p>
              &euro;&nbsp;{{ formatPrice((result.fixed_interest / 100) * result.worth, true) }}
            </p>
          </td>
          <td
            :class="['value', { 'red': result.propertyError }]"
            :title="profileInfo(result.profile, 'property')"
          >
            {{ formatPrice(result.property) }}%<br>
            <p>
              &euro;&nbsp;{{ formatPrice((result.property / 100) * result.worth, true) }}
            </p>
          </td>
          <td
            :class="['value', { 'red': result.protectedInvestingError }]"
            :title="profileInfo(result.profile, 'protected_investing')"
          >
            {{ formatPrice(result.protected_investing) }}%<br>
            <p>
              &euro;&nbsp;{{ formatPrice((result.protected_investing / 100) * result.worth, true) }}
            </p>
          </td>
          <td
            :class="['value', { 'red': result.alternativesError }]"
            :title="profileInfo(result.profile, 'alternatives')"
          >
            {{ formatPrice(result.alternatives) }}%<br>
            <p>
              &euro;&nbsp;{{ formatPrice((result.alternatives / 100) * result.worth, true) }}
            </p>
          </td>
          <td
            :class="['value', { 'red': result.liquiditiesError }]"
            :title="profileInfo(result.profile, 'liquidities')"
          >
            {{ formatPrice(result.liquidities) }}%<br>
            <p>
              &euro;&nbsp;{{ formatPrice((result.liquidities / 100) * result.worth, true) }}
            </p>
          </td>
          <td
            :class="['value', { 'red': result.foreignCurrencyError }]"
            :title="profileInfo(result.profile, 'foreign_currency')"
          >
            {{ formatPrice(result.foreign_currency) }}%<br>
            <p>
              &euro;&nbsp;{{ formatPrice((result.foreign_currency / 100) * result.worth, true) }}
            </p>
          </td>
          <td class="concat100">
            <span :class="{ 'red': result.horizonError }">
              {{ new Date(result.horizon).toLocaleDateString() }}
            </span> <br />
            <i>{{
              find(users, { id: result.manager })
                ? find(users, { id: result.manager }).email
                : result.manager
            }}</i>
          </td>
          <td>
            <button v-if="result.busyIntake" @click="doOpen(result.busyIntake)" class="secondary">
              <awesomeIcon icon="redo-alt" :title="`Vervolg intake ${result.busyIntake}`" />
            </button>
            <button v-else @click="redoIntake(result.port)" class="secondary">
              <awesomeIcon icon="clipboard-list" title="Open her-intake!" />
            </button>
          </td>
          <td>
            <button @click="viewDetails(result)" class="secondary">
              <awesomeIcon icon="eye" title="Bekijk details"/>
            </button>
          </td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="totalResults"
        :resultsPerPage="maxPerPage"
      />
    </div>
    <div v-else class="loader"></div>
  </div>
</template>

<script>
import { find, sortBy } from 'lodash-es';

export default {
  name: 'RiskModule',
  data() {
    return {
      bandwidths: null,
      detailsModal: false,
      detailsResult: null,
      currentPage: 0,
      maxPerPage: 12,
      totalResults: 0,
      generalSearch: null,
      portDropdown: {},
      profiles: [],
      selectedProfiles: [],
      users: [],
      activeFilters: [],
      filters: [
        {
          name: 'generalInput',
          model: '',
          cookie: 'riskGeneralInput',
          filterName: 'search',
          operator: 'contains',
          operators: ['eq', 'neq', 'contains', 'startswith', 'endswith'],
          title: 'Port',
        },
        {
          name: 'portInput',
          label: 'Portefeuille ID',
          type: 'text',
          cookie: 'riskPortInput',
          model: '',
          filterName: 'port',
          operator: 'contains',
          operators: ['eq', 'neq', 'startswith', 'endswith', 'contains'],
        },
        {
          name: 'managerIdInput',
          label: 'Beheerder',
          type: 'user',
          cookie: 'riskManagerIdInput',
          model: '',
          filterName: 'manager',
          operator: 'eq',
          operators: ['eq', 'neq'],
          roles: [8, 9, 10],
        },
        {
          name: 'maxDate',
          label: 'Horizon tot',
          type: 'date',
          model: '',
          cookie: 'RiskMaxHorizonDateInput',
          filterName: 'date',
          operator: 'eqlt',
          operators: ['eqlt', 'lt'],
          attributes: [
            {
              name: 'min',
              value: this.updateDateLimits('maxmin'),
            },
            {
              name: 'max',
              value: this.updateDateLimits('maxmax'),
            },
          ],
        },
        {
          name: 'activeProfileInput',
          type: 'dropdown',
          cookie: 'riskActiveProfile',
          operator: 'in',
          model: '',
          attributes: [
            {
              name: 'array',
              value: [
                {
                  label: 'Alles',
                  value: 'Alles',
                },
                {
                  label: 'Aan',
                  value: 'Aan',
                },
                {
                  label: 'Uit',
                  value: 'Uit',
                },
              ],
            },
            {
              name: 'defaultValue',
              value: 'Aan',
            },
            {
              name: 'displayPrefix',
              value: 'Profiel: ',
            },
            {
              name: 'cb',
              value: () => {
                this.currentPage = 0;
                this.$refs.filterComp.get();
              },
            },
          ],
        },
        {
          name: 'activeManagerInput',
          type: 'dropdown',
          cookie: 'riskActiveManager',
          operator: 'in',
          model: '',
          attributes: [
            {
              name: 'array',
              value: [
                {
                  label: 'Alles',
                  value: 'Alles',
                },
                {
                  label: 'Aan',
                  value: 'Aan',
                },
                {
                  label: 'Uit',
                  value: 'Uit',
                },
              ],
            },
            {
              name: 'defaultValue',
              value: 'Aan',
            },
            {
              name: 'displayPrefix',
              value: 'Heeft beheerder: ',
            },
            {
              name: 'cb',
              value: () => {
                this.currentPage = 0;
                this.$refs.filterComp.get();
              },
            },
          ],
        },
        {
          name: 'brandInput',
          type: 'multiDropdown',
          filterName: 'brand',
          position: 'topbar',
          cookie: 'riskFilterBrand',
          operator: 'in',
          model: '',
          attributes: [
            {
              name: 'array',
              value: [
                {
                  label: 'Doelbeleggen',
                  value: 'Doelbeleggen',
                },
                {
                  label: 'OXBY',
                  value: 'OXBY',
                },
                {
                  label: 'VMVB',
                  value: 'VMVB',
                },
                {
                  label: 'BVS',
                  value: 'BVS',
                },
              ],
            },
            {
              name: 'displayPrefix',
              value: 'Merk: ',
            },
          ],
        },
        {
          name: 'errorsInput',
          type: 'dropdown',
          cookie: 'riskErrorsGroup',
          operator: 'in',
          model: '',
          attributes: [
            {
              name: 'array',
              value: [
                {
                  label: 'Alles',
                  value: 'none',
                },
                {
                  label: 'Alle alerts',
                  value: 'errors',
                },
                {
                  label: 'Aandelen',
                  value: 'sharesError',
                },
                {
                  label: 'Aandelen (onder)',
                  value: 'sharesMinError',
                },
                {
                  label: 'Aandelen (boven)',
                  value: 'sharesMaxError',
                },
                {
                  label: 'Vast ren.',
                  value: 'fixedInterestError',
                },
                {
                  label: 'Vast ren. (onder)',
                  value: 'fixedInterestMinError',
                },
                {
                  label: 'Vast ren. (boven)',
                  value: 'fixedInterestMaxError',
                },
                {
                  label: 'Vastgoed',
                  value: 'propertyError',
                },
                {
                  label: 'Vastgoed (onder)',
                  value: 'propertyMinError',
                },
                {
                  label: 'Vastgoed (boven)',
                  value: 'propertyMaxError',
                },
                {
                  label: 'Beschermd bel.',
                  value: 'protectedInvestingError',
                },
                {
                  label: 'Beschermd bel. (onder)',
                  value: 'protectedInvestingMinError',
                },
                {
                  label: 'Beschermd bel. (boven)',
                  value: 'protectedInvestingMaxError',
                },
                {
                  label: 'Alternatieven',
                  value: 'alternativesError',
                },
                {
                  label: 'Alternatieven (onder)',
                  value: 'alternativesMinError',
                },
                {
                  label: 'Alternatieven (boven)',
                  value: 'alternativesMaxError',
                },
                {
                  label: 'Liquiditeiten',
                  value: 'liquiditiesError',
                },
                {
                  label: 'Liquiditeiten (onder)',
                  value: 'liquiditiesMinError',
                },
                {
                  label: 'Liquiditeiten (boven)',
                  value: 'liquiditiesMaxError',
                },
                {
                  label: 'Vreemde val.',
                  value: 'foreignCurrencyError',
                },
                {
                  label: 'Vreemde val. (onder)',
                  value: 'foreignCurrencyMinError',
                },
                {
                  label: 'Vreemde val. (boven)',
                  value: 'foreignCurrencyMaxError',
                },
                {
                  label: 'Horizon',
                  value: 'horizonError',
                },
              ],
            },
            {
              name: 'defaultValue',
              value: 'errors',
            },
            {
              name: 'cb',
              value: () => {
                this.currentPage = 0;
                this.$refs.filterComp.get();
              },
            },
          ],
        },
        {
          name: 'sortInput',
          type: 'dropdown',
          position: 'topbar',
          cookie: 'riskSortGroup',
          model: '',
          attributes: [
            {
              name: 'array',
              value: [
                {
                  label: 'Port',
                  value: 'port',
                },
                {
                  label: 'Aandelen (%)',
                  value: 'shares',
                },
                {
                  label: 'Vast ren. (%)',
                  value: 'fixedInterest',
                },
                {
                  label: 'Vastgoed (%)',
                  value: 'property',
                },
                {
                  label: 'Beschermd bel (%)',
                  value: 'protectedInvesting',
                },
                {
                  label: 'Alternatieven (%)',
                  value: 'alternatives',
                },
                {
                  label: 'Liquiditeiten (%)',
                  value: 'liquidities',
                },
                {
                  label: 'Vreemde val. (%)',
                  value: 'foreignCurrency',
                },
                {
                  label: 'Horizon',
                  value: 'horizon',
                },
              ],
            },
            {
              name: 'displayPrefix',
              value: 'Sort: ',
            },
            {
              name: 'defaultValue',
              value: 'horizon',
            },
            {
              name: 'cb',
              value: () => {
                this.currentPage = 0;
                this.$refs.filterComp.get();
              },
            },
          ],
        },
        {
          name: 'sortDirectionInput',
          type: 'dropdown',
          position: 'topbar',
          cookie: 'riskSortDirectionGroup',
          model: '',
          attributes: [
            {
              name: 'array',
              value: [
                {
                  label: 'Aflopend',
                  value: 'desc',
                },
                {
                  label: 'Oplopend',
                  value: 'asc',
                },
              ],
            },
            {
              name: 'defaultValue',
              value: 'asc',
            },
            {
              name: 'cb',
              value: () => {
                this.currentPage = 0;
                this.$refs.filterComp.get();
              },
            },
          ],
        },
      ],
    };
  },
  created() {
    this.sdk.getUsersQuick((response) => {
      if (response.status === 200) {
        this.users = response.data;
        this.getProfiles();
      } else {
        this.sdk.logout();
        window.location.reload();
      }
    });
  },
  watch: {
    currentPage() {
      this.$refs.filterComp.get();
    },
  },
  methods: {
    find,
    doOpen(intake) {
      window.open(`?intake=${intake}`);
    },
    redoIntake(port) {
      this.$store.state.confirm.toggle({
        title: `Her-intake portefeuille ${port}`,
        text: `Weet u zeker dat u een her-intake wilt openen voor portefeuille ${port}?`,
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.redoIntake(port, () => {
              this.$refs.filterComp.get();
            });
          }
        },
      });
    },
    profileInfo(profile, category) {
      const profileData = find(this.profiles, { id: Number(profile) });
      if (profileData) {
        if (category === 'foreign_currency') {
          return `${profileData[`${category}_min`]} - ${profileData[`${category}_max`]}`;
        }
        return `${profileData[`${category}_min`]} - ${profileData[`${category}_target`]} - ${profileData[`${category}_max`]}`;
      }
      return '?';
    },
    updateDateLimits(type) {
      if (type === 'maxmin' && this.minDateFilter) {
        return this.formatDate(new Date(this.minDateFilter));
      }
      if (type === 'maxmax') {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 1);
        return this.formatDate(currentDate);
      }
      return '';
    },
    formatDate(date) {
      return `${date.getFullYear()}-${
        date.getMonth() < 9 ? '0' : ''}${date.getMonth() + 1
      }-${
        date.getDate() < 10 ? '0' : ''}${date.getDate()
      }`;
    },
    openUserInCrm(user) {
      this.sdk.getUserCRM(user, (response) => {
        if (response.status === 200) {
          window.open(
            `https://vmvb.crm4.dynamics.com/main.aspx?forceUCI=1&pagetype=entityrecord&etn=contact&id=${response.data.id}`,
            '_blank',
          );
        } else {
          // eslint-disable-next-line
          alert('Gebruiker niet gevonden in Dynamics.');
        }
      });
    },
    viewDetails(result) {
      this.detailsResult = result;
      this.detailsProfile = find(this.profiles, { id: result.profile }) || {};
      this.sdk.getPortIntake(result.port, (response) => {
        if (response.status === 200) {
          this.detailsResult.user = response.data.client;
          this.detailsModal = true;
        } else {
          // No intake in port
          this.detailsModal = true;
        }
      });
    },
    getProfiles() {
      this.sdk.getProfiles((response) => {
        if (response.status === 200) {
          this.profiles = sortBy(response.data, (profile) => profile.name);
          this.$refs.filterComp.get();
          const parsedProfiles = this.profiles.map(
            (profile) => ({
              label: profile.name,
              value: profile.id,
            }),
          );
          this.filters.push({
            name: 'profileInput',
            type: 'multiDropdown',
            cookie: 'riskProfileInput',
            filterName: 'profile',
            model: '',
            operator: 'in',
            attributes: [
              {
                name: 'array',
                value: parsedProfiles,
              },
              {
                name: 'displayPrefix',
                value: 'Profielen',
              },
            ],
          });
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
    getBandwidths(newSearch, filter = '', activeFilters = []) {
      this.bandwidths = null;
      this.activeFilters = activeFilters;

      if (this.activeFilters.length) {
        this.$refs.filterComp.toggle(true);
      }

      const activeProfileValue = this.$refs.filterComp.getValue('activeProfileInput');

      if (activeProfileValue) {
        this.createCookie('riskActiveProfile', activeProfileValue);
      } else {
        this.eraseCookie('riskActiveProfile');
      }

      if (activeProfileValue === 'Aan') {
        filter.push('profile neq 0');
      }

      if (activeProfileValue === 'Uit') {
        filter.push('profile eq 0');
      }

      const activeManagerValue = this.$refs.filterComp.getValue('activeManagerInput');

      if (activeManagerValue) {
        this.createCookie('riskActiveManager', activeManagerValue);
      } else {
        this.eraseCookie('riskActiveManager');
      }

      if (activeManagerValue === 'Aan') {
        filter.push('manager neq 0');
      }

      if (activeManagerValue === 'Uit') {
        filter.push('manager eq 0');
      }

      // Check sorting filter
      const sort = this.$refs.filterComp.getValue('sortInput');
      const sortDirection = this.$refs.filterComp.getValue('sortDirectionInput');
      // Added standard filters. Port, profile and value should
      filter.push('port neq \'\'');
      filter.push('value gt 0'); // Ports need worth
      filter.push('status neq 3'); // Ports that are not closed
      filter.push('closed neq 1');

      // Filter for errors (alerts)
      const currentErrorValue = this.$refs.filterComp.getValue('errorsInput');
      if (currentErrorValue && currentErrorValue !== 'none') {
        this.createCookie('riskErrorsGroup', currentErrorValue);
        filter.push(`${currentErrorValue} neq 0`);
      } else {
        this.eraseCookie('riskErrorsGroup');
      }

      if (filter.length) {
        filter = filter.join(';');
      }

      if (newSearch) {
        this.currentPage = 0;
      }

      this.sdk.getBandwidthRisks((response) => {
        if (response.status === 200) {
          this.totalResults = response.data.totalRows;
          for (let i = 0; i < response.data.results.length; i += 1) {
            for (let j = 0; j < this.profiles.length; j += 1) {
              if (this.profiles[j].id === response.data.results[i].profile) {
                response.data.results[i].profileName = this.profiles[j].name;

                response.data.results[i].sharesError = (
                  response.data.results[i].shares < this.profiles[j].shares_min
                  || response.data.results[i].shares > this.profiles[j].shares_max
                );

                response.data.results[i].fixedInterestError = (
                  response.data.results[i].fixed_interest < this.profiles[j].fixed_interest_min
                  || response.data.results[i].fixed_interest > this.profiles[j].fixed_interest_max
                );

                response.data.results[i].propertyError = (
                  response.data.results[i].property < this.profiles[j].property_min
                  || response.data.results[i].property > this.profiles[j].property_max
                );

                response.data.results[i].protectedInvestingError = (
                  response.data.results[i].protected_investing
                  < this.profiles[j].protected_investing_min
                  || response.data.results[i].protected_investing
                  > this.profiles[j].protected_investing_max
                );

                response.data.results[i].alternativesError = (
                  response.data.results[i].alternatives < this.profiles[j].alternatives_min
                  || response.data.results[i].alternatives > this.profiles[j].alternatives_max
                );

                response.data.results[i].liquiditiesError = (
                  response.data.results[i].liquidities < this.profiles[j].liquidities_min
                  || response.data.results[i].liquidities > this.profiles[j].liquidities_max
                );

                response.data.results[i].foreignCurrencyError = (
                  response.data.results[i].foreign_currency
                  < this.profiles[j].foreign_currency_min
                  || response.data.results[i].foreign_currency
                  > this.profiles[j].foreign_currency_max
                );

                const futureDate = new Date(new Date().getTime()
                  + (this.profiles[j].horizon_min * 24 * 60 * 60 * 1000));

                response.data.results[i].horizonError = (
                  new Date(response.data.results[i].horizon) < futureDate
                );

                break;
              }
            }

            response.data.results[i].busyIntake = response.data.results[i].busyIntakes
            && response.data.results[i].busyIntakes[0]
              ? response.data.results[i].busyIntakes[0].id
              : '';
            delete response.data.results[i].busyIntakes;
          }
          this.bandwidths = response.data.results;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      }, filter, this.currentPage, this.maxPerPage, sort, sortDirection);
    },
  },
};
</script>

<style lang="scss" scoped>
  td {
    white-space: nowrap;
  }
  td.value {
    text-align: right;
    cursor: pointer;
    p {
      margin: 0;
      font-size: 12px;
    }
  }
  .no-margin {
    margin: 0;
    cursor: pointer;
    font-style: italic;
  }
</style>
